import { useMemo } from 'react';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import { arraySortFuncMultiKeys } from '@/helpers/common/ArrayHelper';
import { statusDisplayOrder } from '@/utils/constants/rfp/client/rfpClientViewRequestStatus';
import { VIEW_REQUEST_STATUS_UNAPPROVED } from '@/utils/constants/viewRequest/status';
import { getProposalRefuseReason } from '@/utils/modules/rfp/client/rfpClientViewRequestRefuseReason';
import { getStatus } from '@/utils/modules/rfp/client/rfpClientViewRequestStatus';
import { getIsDisclose, getIsDiscloseApproved, } from '@/utils/modules/viewRequest/disclose';
import { getIsProposalRequested } from '@/utils/modules/viewRequest/proposal';
/**
 * データの取得, タブ管理, コンポーネントに渡す値に変更する
 */
export const useRfpClientOneOfferPage = (args) => {
    const { auth, profile, rfp } = args;
    const { is_disclose: rfpIsDisclose, view_requests: viewRequests } = rfp;
    // 開示設定が「開示」か
    const isDisclose = useMemo(() => getIsDisclose(rfpIsDisclose), [rfpIsDisclose]);
    // 開示依頼
    const viewRequestOrders = useMemo(() => viewRequests.filter(({ status }) => status === VIEW_REQUEST_STATUS_UNAPPROVED.value), [viewRequests]);
    const viewRequestTableRows = useMemo(() => viewRequests
        .filter((v) => v.status !== VIEW_REQUEST_STATUS_UNAPPROVED.value)
        .map((v) => {
        var _a;
        const user = {
            companyName: v.organization_name,
            firstName: v.first_name,
            id: `${v.professional_id}`,
            imageSrc: v.photo,
            isShowDetailPage: v.is_show_detail_page,
            lastName: v.last_name,
            professionalType: v.type,
        };
        return {
            companyName: v.organization_name,
            hasOffered: !!v.offer,
            id: v.id,
            isDiscloseApproved: getIsDiscloseApproved(v.is_disclose_approved),
            isProposalRequested: getIsProposalRequested(v.proposal_request_comment),
            proposalRefuseReason: getProposalRefuseReason(v.proposal_send_off_reason, v.proposal_send_off_reason_comment),
            proposalRequestComment: v.proposal_request_comment,
            status: getStatus({
                hasOffer: !!v.offer,
                interviewStatus: (_a = v.offer) === null || _a === void 0 ? void 0 : _a.interview_status,
                viewRequestProposal: v.proposal,
                viewRequestStatus: v.status,
            }),
            urlCode: v.url_code,
            user,
        };
    })
        .sort((leftValue, rightValue) => {
        const left = {
            id: leftValue.id,
            seq: statusDisplayOrder[leftValue.status],
        };
        const right = {
            id: rightValue.id,
            seq: statusDisplayOrder[rightValue.status],
        };
        return arraySortFuncMultiKeys(left, right, ['seq', 'id']);
    }), [viewRequests]);
    // メンバーに関する情報 取得
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    const isAdmin = rfpOneUseCase.useIsAdmin(profile);
    return {
        isAdmin,
        isCanUpdateMember,
        isDisclose,
        isMemberAdmin,
        members,
        viewRequestOrders,
        viewRequestTableRows,
    };
};
